<script>
  import { onMount, createEventDispatcher } from "svelte";
  import { UserStore, TempUserStore } from "./store.js";
  import { TitleList } from "../../store.js";
  import { fly } from 'svelte/transition';
  import * as objectWrapper from "../Utils/ObjectWrapper.js";
  import Field from "../FormField.svelte";
  import SelectList from "../HTMLElements/Select.svelte";
  import TextBox from "../HTMLElements/Textbox.svelte";
  import * as formValidator from "../Utils/ValidateFormFIelds.js";
  import AddressPicker from "../HTMLElements/AddressPicker.svelte";
  // import Modal from "../HTMLElements/Modal.svelte";
  // import ModalMessage from "../HTMLElements/ModalMessage.svelte";
  import CheckBox from "../HTMLElements/CheckBoxInput.svelte";
  import wrappedFetch from "../../wrappedFetch.js";
  import Help from "../help.svelte";
  let wrappedObj = $TempUserStore.registerDetails;

  let isFormValid = true;
  let ref;
  let error = "";
  let showCheckBoxModal = false;
  let username = "registration";

  const isNameAllowed = () => {
    return wrappedFetch(
      "uso/isnameallowed?fn=" + wrappedObj.firstName.value + "&ln=" + wrappedObj.lastName.value
    )
      .then(res => res.json())
      .then(result => {
        return result;
      });
  };

  async function validateForm(event) {
    wrappedObj.firstName.value = wrappedObj.firstName.value.replace("’", "'").replace("‘", "'");
    wrappedObj.lastName.value = wrappedObj.lastName.value.replace("’", "'").replace("‘", "'");

    isFormValid = true;
    event.preventDefault();

    // Mark title dirty/invalid if missing so its own inline error appears,
    // but don't return early — let the rest of the fields get validated too.
    if (!wrappedObj.title.value || (typeof wrappedObj.title.value === 'object' && !wrappedObj.title.value.label)) {
      wrappedObj.title.isDirty = true;
      wrappedObj.title.isValid = false;
    }

    const otherFieldsValid = formValidator.validate(wrappedObj);
    const titleValid = wrappedObj.title.isValid !== false;

    if (!otherFieldsValid || !titleValid) {
      isFormValid = false;
      error = "Please ensure that you have completed the required fields.";
      wrappedObj = wrappedObj;
      return;
    }

    let nameAllowedResult = await isNameAllowed();

    if (!nameAllowedResult) {
      isFormValid = false;
      error = "First or last name is not permitted!";     
      return;
    }

    $UserStore.registerUser.hasCompletedDetailsStep = true;

    dispatch("pageChange", "/register/contactdetails");
  }

  onMount(async function() {
    if ($UserStore.registerUser == null ) 
      dispatch("pageChange", "/register/start"); 

    //ref.focus();
  });


  const dispatch = createEventDispatcher();

</script>

<form class="box" autocomplete="off">
  <div class="field">
    <a href="/register/start">
      <span class="fas fa-arrow-left" />
      Back
    </a>
  </div>
  <hr />
  <h1 class="title is-4">New Account</h1>
  <p class="subtitle is-6">Please enter your details below.</p>

  <Field label="Title" role="dropdown" aria-label="Select your title" isRequired={true}>
    <span slot="inputField" >
      <SelectList
        items={TitleList}
        label= "your title"
        readoutLabel= "title"
        selectedValueText="label"
        placeholder="Select your title"
        isRequired="true"
        bind:selectedValue={wrappedObj.title.value}
        bind:isValid={wrappedObj.title.isValid}
        bind:isDirty={wrappedObj.title.isDirty} 
        />
      <!-- bind:this={wrappedObj.title.component} -->
    </span>
  </Field>

  <Field label="First name">
    <span slot="inputField">
      <TextBox
        placeholder="John"
        isRequired="true"
        bind:text={wrappedObj.firstName.value}
        bind:isValid={wrappedObj.firstName.isValid}
        bind:isDirty={wrappedObj.firstName.isDirty}
        label="your first name"
        readoutLabel= "first name " />
    </span>
  </Field>

  <Field label="Last name">
    <span slot="inputField">
      <TextBox
        placeholder="Smith"
        isRequired="true"
        bind:text={wrappedObj.lastName.value}
        bind:isValid={wrappedObj.lastName.isValid}
        bind:isDirty={wrappedObj.lastName.isDirty}
        label="your last name"/>
    </span>
  </Field>

  <Field

    label="Postcode">
    <span slot="inputField">
      <AddressPicker
        bind:selectedAddress={wrappedObj.address.value}
        bind:isValid={wrappedObj.address.isValid}
        bind:isAddressDirty={wrappedObj.address.isDirty}
        bind:postcode={wrappedObj.postcode.value}
        bind:isPostcodeDirty={wrappedObj.postcode.isDirty}
        bind:isPostcodeValid={wrappedObj.postcode.isValid}
        bind:username={username}
        isRequired="true" 
        label="postcode"/>
    </span>
  </Field> 
     <CheckBox     
      helpId="help36"
      label=" I am a Crown servant"
      bind:checked={wrappedObj.isMemberOfCrownService.value}
      bind:showModal={showCheckBoxModal}
      on:change={()=>{if (wrappedObj.isMemberOfCrownService.value) showCheckBoxModal = true;}} />
  <!-- <div class="field">
   <label class="checkbox">
    <input
      type="checkbox"
      bind:checked={wrappedObj.isMemberOfCrownService.value} />
    I am a member of the Crown service
    <div on:click={()=>{showModal = true}} class="help is-info" >  
      <span class="fas fa-info-circle" style="margin-left:5px; font-size: 16px;" />
    </div>
  </label>
</div> -->

<!-- <Modal bind:showModal={showModal}  >
 <h1 class="title">Crown Services</h1>
 <p>An application for admission to a school shall be accompanied by official confirmation of the relocation
    date from the Ministry of Defence, Foreign and Commonwealth Office or Government Communications Headquarters.</p>
  <p>This must be provided to your Home Authority.</p>
</Modal> -->

  <hr />

  {#if !isFormValid}
    <div class="notification is-invalid">
      <p class="help" style="margin-bottom:0px">{error}</p>
    </div>
  {/if}
  <div style="text-align: right;">
    <button type="submit" class="button is-purple" on:click={validateForm}>
      Continue
    </button>
  </div>
</form>
<!-- <Modal bind:showModal >
   <Help
      helpId="Help19"
      showSearchOption={false}
      showContent={false}
      doAnimation={false} />
  </Modal>
<Modal bind:showModal={showCrownModal} on:closed={()=>{showCrownModal = false}} >
  <Help
    helpId="Help36"
    showSearchOption={false}
    showContent={false}
    doAnimation={false} />
  
  <!-- <footer class="modal-card-foot buttons is-right" slot="footer">
    <button class="button continue" on:click={handleModalContinue}>
      Continue
    </button>
  </footer>
</Modal> -->